module.exports = __webpack_public_path__ + "static/media/notifications.edeb2bfc.png";